module.exports = __webpack_public_path__ + "static/media/educational-sponsor-sait.bcaa98d3.png";